import React from 'react';
import Newsletter from './Newsletter';
import Link from 'components/Link';
import PreFooter from './PreFooter';
import Navigation from './Navigation';
import TagManagerService from 'services/TagManager';
import { footerTxt } from 'config/translate/variables';
import style from './style.scss'; //NOSONAR

const Footer = () => {

    const clickLinkFooter = (action, tag) => {
        TagManagerService.footer(action, tag);
    };

    return(
        <footer className="footer">
            <Newsletter />
            <PreFooter />
            <Navigation />
            <div className="footer-copyright">
                <Link to="/institucional/terminos-condiciones" className="footer-copyright-link" onClick={() => clickLinkFooter('Términos y Condiciones', '/institucional/terminos-condiciones')}>Términos y Condiciones</Link>
                <span> | </span>
                <Link to="/institucional/seguridad-privacidad" className="footer-copyright-link" onClick={() => clickLinkFooter('Seguridad y Privacidad', '/institucional/seguridad-privacidad')}>Seguridad y Privacidad</Link>
                <span>{footerTxt.copyright}</span>
            </div>
        </footer>
    )
};

export default Footer;
